<svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.32143 7.72215L0.75 4.15073L1.75714 3.14358L4.32143 5.70073L9.74286 0.279297L10.75 1.29358L4.32143 7.72215Z" fill="white"/>
</svg>
